import { action } from 'app/actions';

export const GET_CLASSES_OPTIONS = 'simulated/content-map/GET_CLASSES_OPTIONS';
export const GET_CURRICULAR_OPTIONS = 'simulated/content-map/GET_CURRICULAR_OPTIONS';
export const GET_UNITS_OPTIONS = 'simulated/content-map/GET_UNITS_OPTIONS';
export const GET_CURRICULAR_ABILITY_OPTIONS =
  'simulated/content-map/GET_CURRICULAR_ABILITY_OPTIONS';
export const GET_UNITS_ABILITY_OPTIONS = 'simulated/content-map/GET_UNITS_ABILITY_OPTIONS';
export const GET_EVALUATION_INFORMATION = 'simulated/content-map/GET_EVALUATION_INFORMATION';
export const GET_HABILITIES = 'simulated/content-map/GET_HABILITIES';
export const CLEAR_FILTER = 'simulated/content-map/CLEAR_FILTER';
export const APPLY_FILTER = 'simulated/content-map/APPLY_FILTER';
export const ADD_CONTENT_MAP_HABILITY = 'simulated/content-map/ADD_CONTENT_MAP_HABILITY';
export const EDIT_CONTENT_MAP_HABILITY = 'simulated/content-map/EDIT_CONTENT_MAP_HABILITY';
export const APPROVE_CONTENT_MAP_HABILITY = 'simulated/content-map/APPROVE_CONTENT_MAP_HABILITY';
export const REPROVE_CONTENT_MAP_HABILITY = 'simulated/content-map/REPROVE_CONTENT_MAP_HABILITY';
export const CHECK_COORDINATOR_PERMISSION = 'simulated/content-map/CHECK_COORDINATOR_PERMISSION';
export const APPROVE_ALL_ABILITIES = 'simulated/content-map/APPROVE_ALL_ABILITIES';
export const RESET_APPROVE_ALL_ABILITIES_STATUS =
  'simulated/content-map/RESET_APPROVE_ALL_ABILITIES_STATUS';

export const getClassesOptions = payload => action(GET_CLASSES_OPTIONS, { payload });
export const getCurricularOptions = payload => action(GET_CURRICULAR_OPTIONS, { payload });
export const getUnitsOptions = payload => action(GET_UNITS_OPTIONS, { payload });
export const getCurricularAbilityOptions = payload =>
  action(GET_CURRICULAR_ABILITY_OPTIONS, { payload });
export const getUnitsAbilityOptions = payload => action(GET_UNITS_ABILITY_OPTIONS, { payload });
export const getEvaluationInformation = payload => action(GET_EVALUATION_INFORMATION, { payload });
export const getAbilities = payload => action(GET_HABILITIES, { payload });
export const clearFilter = payload => action(CLEAR_FILTER, { payload });
export const applyFilter = payload => action(APPLY_FILTER, { payload });
export const addContentMapAbility = payload => action(ADD_CONTENT_MAP_HABILITY, { payload });
export const editContentMapAbility = payload => action(EDIT_CONTENT_MAP_HABILITY, { payload });
export const approveContentMapAbility = payload =>
  action(APPROVE_CONTENT_MAP_HABILITY, { payload });
export const reproveContentMapAbility = payload =>
  action(REPROVE_CONTENT_MAP_HABILITY, { payload });
export const checkCoordinatorPermission = payload =>
  action(CHECK_COORDINATOR_PERMISSION, { payload });
export const approveAllAbilities = payload => action(APPROVE_ALL_ABILITIES, { payload });
export const resetApproveAllAbilitiesStatus = () => action(RESET_APPROVE_ALL_ABILITIES_STATUS);
